import { useContributionMessages } from 'src/api/contribution'
import { asModal } from 'src/components/hoc/asModal'
import { UserIcon } from 'src/components/Image/UserIcon'
import { Link } from 'src/elements/Link'
import { black, truewhite, _contributiontext } from 'src/styles/colors'
import styled from 'styled-components'

type ContributionMessagesModalProps = {
  id: number
}
export const ContributionMessagesModal =
  asModal<ContributionMessagesModalProps>(
    ({ id }) => {
      const { data = [] } = useContributionMessages(id)
      return (
        <Layout>
          {data.length ? (
            data.map((message) => (
              <MessageDiv key={message.roomUrl}>
                <Date>{message.createdAt.format('MM/DD')}</Date>
                <UserInfo>
                  <UserIcon src={message.ionSrc} size="40px" />
                  <div>
                    <CompanyName>{message.companyName}</CompanyName>
                    <p>{message.name}</p>
                  </div>
                </UserInfo>
                <Link href={`${message.roomUrl}/${message.contributionId}`}>
                  <Button type="button">メッセージを見る</Button>
                </Link>
              </MessageDiv>
            ))
          ) : (
            <p>メッセージはありません</p>
          )}
        </Layout>
      )
    },
    {
      scrollable: true,
    },
  )

const Layout = styled.div`
  max-width: min(72vw, 560px);
  max-height: 80vh;
  padding: 20px 10px;
  border-radius: 10px;
  background: ${black};
  overflow-y: auto;
  p {
    color: ${truewhite};
    white-space: pre-wrap;
  }
`

const Button = styled.button`
  padding: 10px 20px;
  border-radius: 16px;
  background-color: ${_contributiontext};
  color: ${truewhite};
  font-size: 12px;
`
const MessageDiv = styled.div`
  margin: 20px 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  > * {
    margin: 5px;
  }
  @media screen and (min-width: 720px) {
    flex-direction: row;
  }
`
const Date = styled.p`
  font-size: 12px;
`
const UserInfo = styled.div`
  display: flex;
  align-items: center;
  > * {
    margin: 0 5px;
  }
`
const CompanyName = styled.p`
  font-size: 12px;
`
